import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext();

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};

export const HeaderProvider = ({ children }) => {
  const [headerCollapsed, setHeaderCollapsed] = useState(false);

  const toggleHeaderCollapse = () => {
    setHeaderCollapsed(!headerCollapsed);
  };

  return (
    <HeaderContext.Provider value={{
      headerCollapsed,
      setHeaderCollapsed,
      toggleHeaderCollapse
    }}>
      {children}
    </HeaderContext.Provider>
  );
};
